import type { ChecklistTemplate } from '@/types/settings';

export const CHECKLIST_PAGE_SIZE = 25;

export type ChecklistPageStatusFilter = 'active' | 'archived';

export type ChecklistColumn =
  | 'definition'
  | 'status'
  | 'visibility'
  | 'sections'
  | 'items'
  | 'jobTypes'
  | 'version'
  | 'updatedAt';

export const CHECKLIST_STATUS_OPTIONS: { value: ChecklistPageStatusFilter; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
];

export function getChecklistSortValue(
  key: ChecklistColumn,
  template: ChecklistTemplate,
  jobTypeNames: (template: ChecklistTemplate) => string,
  totalItems: (template: ChecklistTemplate) => number,
) {
  switch (key) {
    case 'definition':
      return template.name;
    case 'status':
      return template.status === 'ARCHIVED' || template.isDeleted ? 'archived' : 'active';
    case 'visibility':
      return template.defaultVisibility ?? 'INTERNAL';
    case 'sections':
      return template.sections.length;
    case 'items':
      return totalItems(template);
    case 'jobTypes':
      return jobTypeNames(template);
    case 'version':
      return template.version ?? 1;
    case 'updatedAt':
      return template.updatedAt ?? '';
  }
}

export function compareChecklistValues(
  left: string | number | boolean,
  right: string | number | boolean,
) {
  if (typeof left === 'number' && typeof right === 'number') return left - right;
  return String(left).localeCompare(String(right), undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}
